import Vue from 'vue';
import {Mixin} from 'vue-mixin-decorator';
import {getModule} from 'vuex-module-decorators';

import {ILogger} from '@/utils/ILogger';
import {LogdownLogger} from '@/utils/LogdownLogger';

import {AppStore} from '@/store/App.store';

@Mixin
export class BaseComponent extends Vue {

  private static loadingComponents: Map<string, boolean> = new Map();

  protected loading: boolean = false;

  protected componentId: string = this.$options.name || 'undef-component-id';

  protected logger: ILogger = new LogdownLogger(this.componentId);

  private internalAppStore: AppStore = getModule(AppStore, this.$store);

  get docsUrl(): string | undefined {
    return process.env.VUE_APP_DOCS_URL;
  }

  protected setLoading() {
    this.logger.trace('Loading');
    this.loading = true;
    BaseComponent.loadingComponents.set(this.componentId, true);
    this.refreshLoading();
  }

  protected setLoaded() {
    this.logger.trace('Loaded');
    this.loading = false;
    BaseComponent.loadingComponents.set(this.componentId, false);
    this.refreshLoading();
  }

  protected get Loading(): boolean {
    return this.loading;
  }

  private refreshLoading() {

    for (const [k, value] of BaseComponent.loadingComponents) {

      if (value) {
        this.internalAppStore.setLoading(true);
        return;
      }
    }

    this.internalAppStore.setLoading(false);
  }
}
